 (function() {
    const domain = window.location.hostname;

    fetch(`https://limegreen-sparrow-533942.hostingersite.com/validate.php?domain=${domain}`)
      .then(response => response.json())
      .then(data => {
        console.log("Validation Response:", data); // Optional: for debugging
        if (!data.validated) {
          const popup = document.createElement('div');
          popup.style = 'position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.6); display: flex; justify-content: center; align-items: center; z-index: 9999;';
          popup.innerHTML = `
            <div style="background: #fff; padding: 30px; max-width: 400px; text-align: center; border-radius: 10px; box-shadow: 0 0 20px rgba(0,0,0,0.2);">
              <h2 style="margin-bottom: 10px;color:#000;">Theme License Validation Required</h2>
              <p style="margin-bottom: 15px;color:#000;">Please contact us to validate your store domain.</p>
              
              
            </div>
          `;
          document.body.appendChild(popup);
        }
      })
      .catch(error => {
        console.error("Validation check failed:", error);
      });
  })();